module.exports = __webpack_public_path__ + "course-catalog-illustration-01wp6950f814a7c1e991f14d5ad9e65d55e2.png";